<template>
    <div class="flat-view">
        <amf-form title="Claim Rejection Codes" class="container-fluid" :menu-items="['Add New Code']">
            <v-client-table v-if="rejectionCodes.length && !busy" :data="rejectionCodes" :columns="columns"
                :options="tableOptions" ref="codestable">
                <template v-slot:code="{ row }">
                    <div>
                        <a href="#" @click.prevent="openEditor(row)">{{ row.code }}</a>
                    </div>
                </template>
                <template v-slot:description="{ row }">
                    <div>
                        {{ shortDescription(row.description) }}
                    </div>
                </template>
                <template v-slot:clientMessages="{ row }">
                    <div>
                        {{ clientMessages(row) }}
                    </div>
                </template>
                <template v-slot:plans="{ row }">
                    <div>
                        {{ row.plans ? row.plans : 'All' }}
                    </div>
                </template>
                <template v-slot:active="{ row }">
                    <div>
                        {{ row.active ? 'Active' : 'Inactive' }}
                    </div>
                </template>
                <template v-slot:frequentlyUsed="{ row }">
                    <div>
                        {{ row.frequentlyUsed ? 'Yes' : 'No' }}
                    </div>
                </template>
            </v-client-table>
        </amf-form>
    </div>
</template>

<script>
    import ClaimRejectionCodeEditor from './ClaimRejectionCodeEditor';
import { copyCommonProperties } from './utils/utils';

    export default {
        components: { ClaimRejectionCodeEditor },
        data() {
            return {
                rejectionCodes: [],
                tableOptions: {
                    ...utils.getVueTablesOptions(),
                    pagination: {
                        chunk: 1000,
                        dropdown: false
                    },
                    headings: {
                        code: 'Code',
                        description: 'Description',
                        plans: 'Plans',
                        clientMessages: 'Client Messages',
                        active: 'Active',
                        frequentlyUsed: 'Frequently Used'
                    },
                    uniqueKey: "id",
                    perPageValues: [],
                    perPage: 30,
                    texts: {
                        filter: null,
                        count: ''
                    },
                    showChildRowToggler: false,
                    sortable: []
                }
            }
        },
        computed: {
            columns() {
                return Object.keys(this.tableOptions.headings)
            }
        },
        created() {
            this.load();
        },
        methods: {
            async load() {
                this.busy = true;
                this.rejectionCodes = await romeApi.get('claim-rejection-code');
                this.busy = false;
            },
            async toggleStatus(rejectionCode) {
                var activate = !rejectionCode.active;
                var c = await modalService.confirm(`Are you sure you want to ${activate ? 'Activate' : 'Deactivate'} this rejection code?`);

                if(c) {
                    await romeApi.post(`claim-rejection-code/${rejectionCode.id}/${activate ? 'activate' : 'deactivate'}`);
                    await this.load();
                    toastService.success('Rejection has been updated');
                }
            },
            async openEditor(rejectionCode) {
                let result = await modalService.show('claim-rejection-code-editor', ClaimRejectionCodeEditor, { rejectionCode });
                if(!result) return;
                this.load();
            },
            async addNewCode() {
                await modalService.show('claim-rejection-code-editor', ClaimRejectionCodeEditor, { isNew: true });
                await this.load();
            },
            shortDescription(description) {
              if(description.length > 125)
                description = `${description.substring(0, 125)}...`;
              return description;
            },
            clientMessages(code) {
              var where = [];
              if(code.chat) where.push('Chat');
              if(code.ivr) where.push('IVR');
              if(code.pPortal) where.push('Participant Portal');

              if(where.length) return where.join(',');
              return 'Default';
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/framework/ClaimRejectionCodes.vue